module.exports = __webpack_public_path__ + "static/media/tire-wheel-product.31055c01.png";